require('jschr-bootstrap-modal/js/bootstrap-modalmanager');
require('jschr-bootstrap-modal/js/bootstrap-modal');
import { createVueApp } from '/webpack-assets/vue/apps/app';

const headerElement = document.getElementById('headerVue');

if (headerElement && !headerElement.__vue_app__) {
  headerElement.__vue_app__ = true;

  createVueApp({
    controller: 'common/header',
    method: 'Header',
    appID: '#headerVue',
  });
}
